import { __decorate, __metadata } from "tslib";
import { h, Host } from "@stencil/core";
import { Logger } from "../../../utils/log";
import { BEM } from "../../../utils/bem";
export class NavLinkGridCol {
    constructor() {
        this.staticCol = false;
    }
    createLogger(log) {
        this.log = log;
    }
    /**
     * RENDER
     * ------------------------------------------------------
     */
    render() {
        const block = BEM.block('nav-link-grid-col');
        const innerEl = block.element('inner');
        return (h(Host, { key: '570396a3ad6882891cfefebf9d92dae1137a3f48', class: Object.assign(Object.assign({}, block.class()), block.modifier('is-static').class(this.staticCol)) }, h("div", { key: '86f6add382f5accf09aef4593b16281268af8241', class: Object.assign({}, innerEl.class()) }, h("slot", { key: '57160d0fd8135f4d8a4d955a019ae41b28fc2123' }))));
    }
    static get is() { return "bal-nav-link-grid-col"; }
    static get originalStyleUrls() {
        return {
            "$": ["bal-nav-link-grid-col.sass"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["bal-nav-link-grid-col.css"]
        };
    }
    static get properties() {
        return {
            "staticCol": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "BalProps.BalNavLinkGridCol",
                    "resolved": "boolean",
                    "references": {
                        "BalProps": {
                            "location": "global",
                            "id": "global::BalProps"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Defines the static column which is always aligned to the right"
                },
                "getter": false,
                "setter": false,
                "attribute": "static-col",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
}
__decorate([
    Logger('bal-nav-link-grid-col'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function]),
    __metadata("design:returntype", void 0)
], NavLinkGridCol.prototype, "createLogger", null);
